import { render } from "./PrintOrder.vue?vue&type=template&id=540061b3&scoped=true"
import script from "./PrintOrder.vue?vue&type=script&lang=js"
export * from "./PrintOrder.vue?vue&type=script&lang=js"

import "./PrintOrder.vue?vue&type=style&index=0&id=540061b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540061b3"]])

export default __exports__